var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"circleButton",class:[ _vm.checked, _vm.sizeClassName ],on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }